// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","368":"confirm","511":"cart","637":"order","845":"profile"}[chunkId] + "." + {"18":"d87aa690","368":"472bf7a0","511":"91f20761","637":"4d8b5233","845":"8afb3ac6"}[chunkId] + ".css";
};